<template>
  <div class="custom-form-box">
    <yd-cell-group v-for="(field,index) in fields" :key="index">
      <yd-cell-group v-if="field.field_name === 'province'">
        <yd-flexbox>
          <yd-flexbox-item>
            <yd-cell-group>
              <yd-cell-item arrow>
                <span slot="left">
                  <b style="color:red"
                     v-if="field.required === '1'"
                  >*</b>省市县：</span>
                <input
                  slot="right" type="text" @click.stop="cityShow = true" v-model="pcd" readonly
                  placeholder="请选择收货地址">
              </yd-cell-item>
            </yd-cell-group>
            <yd-cityselect
              v-model="cityShow"
              :callback="result1"
              :provance="fieldsData_1.province"
              :city="fieldsData_1.city"
              :area="fieldsData_1.area"
              :items="district"
            ></yd-cityselect>
          </yd-flexbox-item>
        </yd-flexbox>
      </yd-cell-group>
      <div v-else-if="field.field_name === 'city' || field.field_name === 'area'"></div>
      <yd-cell-item v-else-if="field.field_type === 'system' || field.field_type === 'text'">
        <span slot="left"><b style="color:red" v-if="field.required === '1'">*</b>{{
            field.field_des
          }}：</span>
        <input
          slot="right" type="text" v-model="fieldsData_1[field.field_name]"
          :placeholder="field.remind"
          @change="updateFieldsData">
      </yd-cell-item>
      <!--单选按钮-->
      <div v-else-if="field.field_type === 'radio'" class="l-form-radio">
        <div class="yd-cell-left">
          <b v-if="isRequired(field)" style="color:red">*</b>
          {{ field.field_des }}：
        </div>
        <div>
          <div
            v-for="(radio, idx) in field.child"
            :key="idx"
            class="yd-cell-right l-radio-item"
          >
            <label class="label">
              <input
                v-model="fieldsData[field.field_name]"
                :name="field.tablename + field.field_name"
                :value="idx"
                type="radio"
                @change="updateFieldsData"
              >
              {{ radio }}
            </label>
          </div>
        </div>
      </div>
      <!--多选按钮-->
      <div v-else-if="field.field_type === 'checkbox'" class="l-form-checkbox">
        <div class="yd-cell-left">
          <b v-if="isRequired(field)" style="color:red">*</b>
          {{ field.field_des }}：
        </div>
        <div>
          <div
            v-for="(item, idx) in field.child"
            :key="idx"
            class="yd-cell-right l-checkbox-item"
          >
            <label class="label">
              <input
                v-model="fieldsData[field.field_name]"
                :name="field.tablename + field.field_name"
                :value="idx"
                type="checkbox"
                @change="updateFieldsData"
              >
              {{ item }}
            </label>
          </div>
        </div>
      </div>
      <div class="yd-cell-item" v-else-if="field.field_type === 'select'">
        <div class="yd-cell-left"><b style="color:red"
                                     v-if="field.required === '1'">*</b>{{ field.field_des }}：
        </div>
        <div class="yd-cell-right">
          <select name="" v-model="fieldsData_1[field.field_name]" @change="updateFieldsData">
            <option value="">请选择</option>
            <option v-for="(select,index) in field.child" :key="index" :value="index">{{
                select
              }}
            </option>
          </select>
        </div>
      </div>
      <div class="yd-cell-item" v-else-if="field.field_type === 'img'">
        <div class="yd-cell-left"><b style="color:red"
                                     v-if="field.required === '1'">*</b>{{ field.field_des }}：
        </div>
        <div class="yd-cell-right">
          <input type="file" :name="field.field_name" @change="fileUpload">
        </div>
      </div>
      <div class="yd-cell-item" v-else-if="field.field_type === 'file'">
        <div class="yd-cell-left"><b style="color:red"
                                     v-if="field.required === '1'">*</b>{{ field.field_des }}：
        </div>
        <div class="yd-cell-right">
          <input type="file" :name="field.field_name" @change="fileUpload">
        </div>
      </div>
      <div class="yd-cell-item" v-else-if="field.field_type === 'date'">
        <div class="yd-cell-left"><b style="color:red"
                                     v-if="field.required === '1'">*</b>{{ field.field_des }}：
        </div>
        <div class="yd-cell-right">
          <input type="date" v-model="fieldsData_1[field.field_name]" @change="updateFieldsData">
        </div>
      </div>
    </yd-cell-group>
  </div>
</template>

<script type="text/babel">
import Vue from 'vue'
import axios from 'axios'
import {CitySelect} from 'vue-ydui/dist/lib.rem/cityselect'
import District from 'ydui-district/dist/gov_province_city_area_id'

Vue.component(CitySelect.name, CitySelect)
export default {
  name: 'cell',
  props: ['fieldsData', 'fields'],
  data () {
    return {
      district: District,
      pcd: '',
      cityShow: false,
      fieldsData_1: this.fieldsData
    }
  },
  methods: {
    isRequired (i) {
      return i.required === '1' || i.control_display_field_rel_required === '1'
    },
    result1 (ret) {
      this.pcd = ret.itemName1 + ' ' + ret.itemName2 + ' ' + ret.itemName3
      this.fieldsData_1.province = ret.itemValue1
      this.fieldsData_1.city = ret.itemValue2
      this.fieldsData_1.area = ret.itemValue3
      this.$emit('refreshData', 'fieldsData', this.fieldsData_1)
    },
    updatepcd () { // 默认地址、 赋值
      let p = ''
      let c = ''
      let d = ''
      District.forEach(item => {
        if (item.v === this.province) {
          p = item.n
          item.c.forEach(itemc => {
            if (itemc.v === this.city) {
              c = itemc.n
              itemc.c.forEach(ic => {
                if (ic.v === this.area) {
                  d = ic.n
                }
              })
            }
          })
        }
      })
      this.pcd = p + ' ' + c + ' ' + d
    },
    updateFieldsData () {
      this.$emit('refreshData', 'fieldsData', this.fieldsData_1)
    },
    fileUpload (event) {
      let file = event.target.files
      let reader = new FileReader()
      reader.readAsDataURL(file[0])
      let _this = this
      reader.onload = function (e) {
        let data = {
          data: e.target.result,
          name: file[0].name
        }
        axios
          .post('/fair/file-upload', data)
          .then(res => {
            res = res.data
            if (res.status) {
              _this.$dialog.toast({mes: res.msg})
              _this.fieldsData_1[event.target.name] = res.data.id
              _this.$emit('refreshData', 'fieldsData', _this.fieldsData_1)
            } else {
              _this.$dialog.toast({mes: res.msg})
            }
          })
      }
    }
  },
  mounted () {
    this.updatepcd()
  },
  watch: {
    fieldsData_1: function () {
      this.$emit('refreshData', 'fieldsData', this.fieldsData_1)
    }
  }
}
</script>
<style lang="stylus" scoped>
.l-cell-textarea
  align-items: flex-start

  >>>
  .yd-textarea
    padding: 0
    background-color: #eee

.l-form-radio, .l-form-checkbox
  padding-left: 0.24rem;

  .label
    width: 100%
    text-align: left

.custom-form-box
  >>>
  .yd-cell
    position: inherit !important
    z-index: 1 !important

  .yd-cell-right
    min-height: 0.6rem
    justify-content: left

    input
      height: 0.6rem
      font-size: 0.28rem
      line-height: 0.6rem

      &::-webkit-input-placeholder,
      &::-moz-placeholder,
      &:-moz-placeholder,
      &:-ms-input-placeholder
        font-size: 0.28rem
        color: #999

    select
      height: 0.6rem
      font-size: 0.28rem
      line-height: 0.6rem
      color: #555
      appearance: menulist-button
      -webkit-appearance: menulist-button
      -moz-appearance: menulist-button

    //单选按钮

    &.l-radio-item
      margin-bottom .1rem

      input[type=radio]
        position: relative
        margin-right: 0.15rem
        border: 1px solid #dcdcdc
        border-radius: 100%
        width: 0.3rem
        height: 0.3rem
        appearance: none
        -webkit-appearance: none

        &:checked
          border: 1px solid #1b54f5

          &:after
            display: block
            position: absolute
            top: 0
            right: 0
            bottom: 0
            left: 0
            margin: auto
            border-radius: 100%
            width: 0.1rem
            height: 0.1rem
            background: #1b54f5
            content: ""

    //多选按钮

    &.l-checkbox-item
      margin-bottom .1rem

      input[type=checkbox]
        &:not(.yd-switch)
          position: relative
          left: 0
          margin-right: 0.2rem
          border: 1px solid #dcdcdc
          width: 0.3rem
          height: 0.3rem
          appearance: none
          -webkit-appearance: none

        &:checked
          border: 1px solid #1b54f5

          &:after
            display: block
            position: absolute
            top: 0
            right: -2px
            bottom: 0
            left: 0
            margin: auto
            width: 0.37rem
            height: 0.3rem
            background: url("~@/assets/image/icon2.png") no-repeat
            background-size: 100% auto
            content: ""
</style>



// WEBPACK FOOTER //
// src/views/template1/compontents/cell.vue